export const PORT_EXPANDER_RNUMBER = 'R35827' as const
export const PORTS_LIMIT = 4 as const

export const ITEMS_NA = ['7', '17']
export const ITEMS_PRESELECTED = ['11', '15', '31', '32', '33', '49', '51', '34', '1', '21', '52']

export const SENSOR_CATEGORY = '2' as const
export const POWER_CATEGORY = '4' as const

export const PX_PER_CHARACTER = 5 as const
export const CONTROL_POWER = 'R35817' as const
export const CONTROL_POWER_DELUXE = 'R35818' as const

export const CONTROL_HUB_IDS = ['1', '3']
export const PRO_HUBS_IDS = ['3', '4']
export const DELUXE_HUBS_IDS = ['4']
export const DELUXE_SINGLE_PROBE_HOLDER = '52' as const

/**
 * Gets the default preselected quantity for an item
 * @param partId - The part ID to check
 * @returns The default quantity (3 for Deluxe Single Probe Holder, 1 for other preselected items, 0 otherwise)
 */
export function getPreselectedQuantity(partId: string): number {
  if (partId === DELUXE_SINGLE_PROBE_HOLDER) return 3
  if (ITEMS_PRESELECTED.includes(partId)) return 1
  return 0
}

/**
 * Gets the minimum allowed quantity for an item (cannot decrease below this)
 * @param partId - The part ID to check
 * @returns The minimum quantity (3 for Deluxe Single Probe Holder, 1 for other preselected items, 0 otherwise)
 */
export function getMinimumQuantity(partId: string): number {
  return getPreselectedQuantity(partId)
}

/**
 * Calculates the billable amount for an item (excluding free preselected quantities)
 * @param partId - The part ID to check
 * @param amount - The current quantity
 * @returns The billable quantity (amount minus preselected free quantity)
 */
export function getBillableQuantity(partId: string, amount: number): number {
  const freeQuantity = getPreselectedQuantity(partId)
  return Math.max(0, amount - freeQuantity)
}
